export default "__VITE_ASSET__DjRCN13v__"